import { createContext } from 'react'
import { blankGlobalTimezoneContextData, GlobalTimezoneContextData } from './models'

export const GlobalTimezoneContext = createContext<GlobalTimezoneContextData>(
  blankGlobalTimezoneContextData
)
